import { useContext } from "react";
import { CookieConsentContext } from "../providers";

export function useCookieConsent() {
  return useContext(CookieConsentContext);
}
